angular.module('eStories.theme', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.theme', {
                url: 'theme/:theme',
                views: {
                    'mainView@': {
                        templateUrl: 'home/theme/theme.tmpl.html',
                        controller: 'ThemeCtrl',
                        controllerAs: 'themeCtrl'
                    }
                }
            });
    }])
    .controller('ThemeCtrl', ['CarouselService', 'AccountModel', 'CatalogModel', '$stateParams', '$location', 'GA',
        function (CarouselService, AccountModel, CatalogModel, $stateParams, $location, GA) {
            var themeCtrl = this;
            var theme = $stateParams.theme;

            CatalogModel.getSectionList([('theme_' + theme).toUpperCase()]).then((response) => {
                themeCtrl.themeSections = response.sectionList;
            });
        }
    ]);